import React from "react";

import { IVenueApi } from "@greeter/venue-api";

export type GreeterVenueApiContextProps = {
  api: IVenueApi;
};
export const GreeterVenueApiContext =
  React.createContext<GreeterVenueApiContextProps>({ api: {} as any });

export function GreeterVenueApiProvider(
  props: GreeterVenueApiContextProps & React.PropsWithChildren
) {
  return (
    <GreeterVenueApiContext value={{ api: props.api }}>
      {props.children}
    </GreeterVenueApiContext>
  );
}

export function useGreeterVenueApi() {
  return React.useContext(GreeterVenueApiContext);
}
